import React from 'react';
import { useAppDispatch, useAppSelector } from '../../../../../../redux/hooks';
import {
  significanceCriteriaSelector,
  significanceErrorSelector,
} from '../../../../../../redux/selectors/builder';
import { setSignificanceControlGroup } from '../../../../../../redux/slices/oldBuilder';
import { assertCondition, assertNotNil } from '../../../../../../utils/types';
import { SignificanceModeKey } from '../../../../../../utils/apollo/graphqlSchema';
import SignificanceFieldValueMenu from '../SignificanceFieldValueMenu';

const SignificanceBreakdownControlGroup = () => {
  const dispatch = useAppDispatch();

  const significanceCriteria = useAppSelector(significanceCriteriaSelector);
  assertCondition(
    significanceCriteria?.modeKey === SignificanceModeKey.Breakdown,
  );
  const { field, controlGroup } = significanceCriteria;
  assertNotNil(field);

  const hasError = useAppSelector((state) =>
    significanceErrorSelector(state, 'controlGroup'),
  );

  const handleChangeGroup = (value: string | null) => {
    dispatch(
      setSignificanceControlGroup({
        modeKey: significanceCriteria.modeKey,
        controlGroup: value,
      }),
    );
  };

  return (
    <SignificanceFieldValueMenu
      field={field}
      value={controlGroup}
      onChange={handleChangeGroup}
      placeholder={'Select control group as a breakdown'}
      hasError={hasError}
    />
  );
};

export default SignificanceBreakdownControlGroup;
